module.exports = __webpack_public_path__ + "static/media/top1.74cc8e13.webp";